/* eslint-disable no-self-assign */
/* eslint-disable no-useless-escape */
/* eslint-disable array-callback-return */
import _ from "underscore";
import moment from "moment";
import { DateTime } from "luxon";
import { remove } from "lodash";
import APP_CONST from "../app/core/shared/constants";
import { StorageHelper } from "./storageHelper";
import i18n from "i18next";

export const constructErrorMsg = (errorObj) => {
  const { responseException } = errorObj;
  const { exceptionMessage } = responseException;
  const { errors } = exceptionMessage;
  let errorResponse = exceptionMessage;
  if (!_.isEmpty(errors)) {
    errorResponse = errors[Object.keys(errors)[0]];
    errorResponse = errorResponse[0];
  }
  return errorResponse;
};

export const fileExtensionRemoval = (value) => {
  return value.replace(/\.[^/.]+$/, "");
};

export const fileInvalidCharsRemoval = (value) => {
  let val = value.replace(/[\/\\:*?"<>|]/g, "_");
  if (val.length > 200) val = val.substring(0, 200);
  return val;
};

export const getFileExtension = (filename) => {
  const ext = /^.+\.([^.]+)$/.exec(filename);
  return ext == null ? "" : ext[1].toLowerCase();
};

export const getFileSize = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const momentLocalConversion = (date, showTime = true) => {
  if (date) {
    const dateFormat = showTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD";
    return moment
      .utc(date, ["YYYY-MM-DD HH:m", "MM-DD-YYYY HH:mm", "YYYY-MM-DD"])
      .local()
      .format(dateFormat);
  }
  return null;
};

export const getUtcCurrentTimeWithHour = () => {
  return moment.utc().format("YYYY-MM-DD HH:mm");
};

export const getFormattedDateTime = (format, fullDate, locale) => {
  if (fullDate === null) {
    return;
  }
  let filterDate = fullDate?.split(".")[0];
  if (fullDate?.includes("Z"))
    filterDate = fullDate?.substring(0, fullDate.length - 1);
  let newdate = new Date(filterDate);
  newdate = new Date(
    Date.UTC(
      newdate.getFullYear(),
      newdate.getMonth(),
      newdate.getDate(),
      newdate.getHours(),
      newdate.getMinutes(),
      newdate.getSeconds()
    )
  );
  // newdate = new Date(`${newdate} UTC`);
  let replacedFormat = format;
  replacedFormat = replacedFormat
    .replace(/\bdddd\b/, "cccc")
    .replace(/\bH:mm:ss tt\b/, "H:mm:ss a")
    .replace(/\bHH:mm:ss tt\b/, "HH:mm:ss a")
    .replace(/\bH:mm tt\b/, "H:mm a")
    .replace(/\bHH:mm tt\b/, "HH:mm a")
    .replace(/\bh:mm:ss tt\b/, "h:mm:ss a")
    .replace(/\bhh:mm:ss tt\b/, "hh:mm:ss a")
    .replace(/\bh:mm tt\b/, "h:mm a")
    .replace(/\bhh:mm tt\b/, "hh:mm a");
  return DateTime.local(
    newdate.getFullYear(),
    newdate.getMonth() + 1,
    newdate.getDate(),
    newdate.getHours(),
    newdate.getMinutes(),
    newdate.getSeconds()
  )
    .setLocale(locale)
    .toFormat(replacedFormat);
};

export const localDateConversion = (date) => {
  let filterDate = date.split(".")[0];
  if (date.includes("Z")) filterDate = date.substring(0, date.length - 1);
  let newdate = new Date(filterDate);
  newdate = new Date(`${newdate} UTC`);
  const addZero = (val) => (val < 10 ? `0${val}` : val);
  if (isNaN(newdate.getTime())) {
    newdate = "";
  } else {
    let hours = newdate.getHours();
    let minutes = newdate.getMinutes();
    const strTime = addZero(hours) + ":" + addZero(minutes);
    newdate =
      newdate.getFullYear() +
      "-" +
      addZero(newdate.getMonth() + 1) +
      "-" +
      addZero(newdate.getDate()) +
      " " +
      strTime;
  }
  return newdate;
};

export const formatDate = (date = null) => {
  if (date) {
    return moment(date).format("YYYY-MM-DD");
  }
};

export const getDateCoverted = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

export const getFormattedDate = (date) => {
  if (date === null || date === undefined) return null;
  const splitedDate = date.split("-");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[parseInt(splitedDate[1]) - 1];
  return `${splitedDate[2]}-${month}-${splitedDate[0]}`;
};

export const getDocumentName = (docInfo) => {
  if (docInfo.tmfdropzoneid) {
    return docInfo.filename;
  }
  switch (docInfo?.title) {
    case "artifactName":
      return docInfo?.displaytemplate;
    case "fileName":
      return docInfo?.documentname;
    case "customName":
      return docInfo?.archivetemplate;
    default:
      return docInfo?.documentname;
  }
};

export const findUserName = (list, id) => {
  const findObj = _.find(list, { guid: id });
  return !_.isEmpty(findObj) ? `${findObj.displayName}` : id;
};

export const constructMetricsInfo = (metrics) => {
  const artifactMetrics = !_.isEmpty(metrics.artifactinfo) ? [...metrics.artifactinfo] : [];
  const zoneMetrics = [];
  const sectionMetrics = [];
  // finding section metrics
  artifactMetrics.forEach((metric) => {
    const lastIndex = metric.artifactid.lastIndexOf(".");
    const id = metric.artifactid.substring(0, lastIndex);
    const obj = remove(sectionMetrics, { sectionid: id })[0];
    let newObj;
    if (!_.isEmpty(obj)) {
      // similar section data
      newObj = {
        sectionid: id,
        awaitingreview: obj.awaitingreview + metric.awaitingreview,
        flaggedbyqc: obj.flaggedbyqc + metric.flaggedbyqc,
        finalized: obj.finalized + metric.finalized,
        unpublished: obj.unpublished + metric.unpublished,
        docrequiredlevels: !_.isEmpty(obj.docrequiredlevels)
          ? obj.docrequiredlevels
          : metric.docrequiredlevels,
        artifactinfo: [...obj.artifactinfo, { ...metric }],
      };
    } else {
      // different section data
      newObj = {
        sectionid: id,
        awaitingreview: metric.awaitingreview,
        flaggedbyqc: metric.flaggedbyqc,
        finalized: metric.finalized,
        unpublished: metric.unpublished,
        docrequiredlevels: metric.docrequiredlevels,
        artifactinfo: [metric],
      };
    }
    sectionMetrics.push(newObj);
  });
  // finding zone metrics
  sectionMetrics.forEach((metric) => {
    const index = metric.sectionid.indexOf(".");
    const id = metric.sectionid.substring(0, index);
    const obj = remove(zoneMetrics, { zoneid: id })[0];
    let newObj;
    if (!_.isEmpty(obj)) {
      // similar zone data
      newObj = {
        zoneid: id,
        awaitingreview: obj.awaitingreview + metric.awaitingreview,
        flaggedbyqc: obj.flaggedbyqc + metric.flaggedbyqc,
        finalized: obj.finalized + metric.finalized,
        unpublished: obj.unpublished + metric.unpublished,
        docrequiredlevels: !_.isEmpty(obj.docrequiredlevels)
          ? obj.docrequiredlevels
          : metric.docrequiredlevels,
        sectioninfo: [...obj.sectioninfo, { ...metric }],
      };
    } else {
      // different zone data
      newObj = {
        zoneid: id,
        awaitingreview: metric.awaitingreview,
        flaggedbyqc: metric.flaggedbyqc,
        finalized: metric.finalized,
        unpublished: metric.unpublished,
        docrequiredlevels: metric.docrequiredlevels,
        sectioninfo: [metric],
      };
    }
    zoneMetrics.push(newObj);
  });
  // getting total count of docs
  let totalMetricsCount = {
    totalawaitingreview: 0,
    totalflaggedbyqc: 0,
    totalfinalized: 0,
    totalunPublished: 0,
  };
  zoneMetrics.forEach((info) => {
    totalMetricsCount = {
      totalawaitingreview:
        totalMetricsCount.totalawaitingreview + info.awaitingreview,
      totalflaggedbyqc: totalMetricsCount.totalflaggedbyqc + info.flaggedbyqc,
      totalfinalized: totalMetricsCount.totalfinalized + info.finalized,
      totalunPublished: totalMetricsCount.totalunPublished + info.unpublished,
    };
  });
  let containDocPercent = 0;
  if (metrics.artifact !== 0) {
    containDocPercent = Math.round(
      (metrics.artifactwithdocuments / metrics.artifact) * 100
    );
  }
  const result = {
    zone: metrics.zone,
    section: metrics.section,
    artifact: metrics.artifact,
    artifactwithdocuments: metrics.artifactwithdocuments,
    artifactmissingdocuments: metrics.artifactmissingdocuments,
    zoneinfo: zoneMetrics,
    awaitingreview: totalMetricsCount.totalawaitingreview,
    finalized: totalMetricsCount.totalfinalized,
    unpublished: totalMetricsCount.totalunPublished,
    flaggedbyqc: totalMetricsCount.totalflaggedbyqc,
    totalDocWithUnpubCount: totalMetricsCount.totalawaitingreview +
      totalMetricsCount.totalflaggedbyqc +
      totalMetricsCount.totalfinalized +
      totalMetricsCount.totalunPublished || 0,
    totaldoccount:
      totalMetricsCount.totalawaitingreview +
      totalMetricsCount.totalflaggedbyqc +
      totalMetricsCount.totalfinalized,
    doccontainspercent: containDocPercent,
    artifactinfo: metrics.artifactinfo,
  };
  return result;
};

export const prepareDownloadRequestPayload = (fileprops) => {
  const passDownloadFileData = {};
  passDownloadFileData.requestPaylod = {};
  if (fileprops.tmfdropzoneid && fileprops.tmfdropzoneid !== "") {
    passDownloadFileData.requestPaylod.documentid = fileprops.tmfdropzoneid;
  } else {
    passDownloadFileData.requestPaylod.documentid =
      fileprops.documentid || fileprops.documentguid || fileprops.fileguid;
  }
  passDownloadFileData.requestPaylod.documentversionguid =
    fileprops.documentversionguid;
  passDownloadFileData.requestPaylod.fileguid =
    fileprops.documentguid || fileprops.fileguid;
  passDownloadFileData.requestPaylod.lastmodifiedon = !fileprops.uploadProgress
    ? fileprops.lastmodifiedon
    : null;
  passDownloadFileData.downloadInfo = {};
  passDownloadFileData.downloadInfo.type =
    fileprops.type || fileprops.fileextension;
  fileprops.downloadtemplate = fileprops.downloadFileName;
  passDownloadFileData.downloadInfo.downloadFileName =
    fileprops.from && fileprops.from === "history"
      ? fileprops.downloadFileName
      : fileprops.downloadtemplate;
  let docAuditDet = {};
  docAuditDet.documentDetails = fileprops;

  passDownloadFileData.passAuditData = {};
  passDownloadFileData.passAuditData.comments = "Not Downloaded";
  passDownloadFileData.passAuditData.keyId = APP_CONST.HARD_CODED.dummyId;
  passDownloadFileData.passAuditData.keyValues = JSON.stringify(docAuditDet);
  passDownloadFileData.passAuditData.action = "Download";
  passDownloadFileData.passAuditData.status = "Error";
  passDownloadFileData.passAuditData.httpAction = "Post";

  return passDownloadFileData;
};

export const getZoneId = (origid) => {
  return origid ? origid.split(".")[0] || "" : "";
};

export const getSectionId = (origid) => {
  const activeOrigid = origid ? origid.split(".") : "";
  return activeOrigid ? `${activeOrigid[0]}.${activeOrigid[1]}` : "";
};

export const constructDocumentUploadObject = (uploadFile, guid, props) => {
  const returnObj = {
    tmflocation: "",
    scope: "",
    etmfurl: "",
    documenttitle: "",
    isStar: false,
    artifact: "",
    documenttmflevel: "",
    documenttype: "",
    zone: "",
    section: "",
    location: "SE - Uppsala University Hospital",
  };
  returnObj.artifactid = parseInt(props.origid?.split(".")[2]);
  returnObj.documentname = uploadFile.name;
  returnObj.type = getFileExtension(uploadFile.name);
  returnObj.tmffilename = uploadFile.name;
  returnObj.origfilename = uploadFile.name;
  returnObj.fileSize = uploadFile.size;
  returnObj.filedate = getUtcCurrentTimeWithHour();
  returnObj.origiartifactid = props.origid;
  returnObj.artifact = props.name;
  returnObj.status = "Unpublished";
  // returnObj.documentguid = `${guid}.${returnObj.type}`;
  returnObj.documentguid = guid;
  returnObj.documentid = guid;
  returnObj.zoneid = getZoneId(props.origid);
  returnObj.sectionid = getSectionId(props.origid);
  returnObj.documentTmfLevelId = APP_CONST.HARD_CODED.dummyId;
  returnObj.isCustomTitle = false;
  returnObj.title = "fileName";
  returnObj.customTitle = null;
  returnObj.datingconventionlabel = props.datingconvention;
  returnObj.version = "";
  returnObj.countriesid = [];
  returnObj.sitesid = [];
  returnObj.documenttype = null;
  returnObj.documenttypevalue = null;
  return returnObj;
};

export const randomNumber = (numbers) => {
  return numbers[Math.floor(Math.random() * numbers.length)];
};

export const prepareDownloadReq = (fileprops) => {
  const passDownloadFileData = {};
  passDownloadFileData.requestPaylod = {};
  if (fileprops.tmfdropzoneid && fileprops.tmfdropzoneid !== "") {
    passDownloadFileData.requestPaylod.documentid = fileprops.tmfdropzoneid;
  } else {
    passDownloadFileData.requestPaylod.documentid =
      fileprops.documentid || fileprops.documentguid || fileprops.fileguid;
  }
  passDownloadFileData.requestPaylod.documentversionguid =
    fileprops.documentversionguid;
  passDownloadFileData.requestPaylod.fileguid =
    fileprops.documentguid || fileprops.fileguid;
  passDownloadFileData.requestPaylod.lastmodifiedon = fileprops.displayOrder
    ? fileprops.lastmodifiedon
    : null;
  passDownloadFileData.downloadInfo = {};
  passDownloadFileData.downloadInfo.type =
    fileprops.type || fileprops.fileextension;
  fileprops.downloadtemplate = fileprops.downloadFileName;
  passDownloadFileData.downloadInfo.downloadFileName =
    fileprops.from && fileprops.from === "history"
      ? fileprops.downloadFileName
      : fileprops.downloadtemplate;
  let docAuditDet = {};
  docAuditDet.documentDetails = fileprops;

  passDownloadFileData.passAuditData = {};
  passDownloadFileData.passAuditData.comments = "Not Downloaded";
  passDownloadFileData.passAuditData.keyId = APP_CONST.HARD_CODED.dummyId;
  passDownloadFileData.passAuditData.keyValues = JSON.stringify(docAuditDet);
  passDownloadFileData.passAuditData.action = "Download";
  passDownloadFileData.passAuditData.status = "Error";
  passDownloadFileData.passAuditData.httpAction = "Post";

  return passDownloadFileData;
};

export const getObjectDiff = (obj1, obj2) => {
  const diff = Object.keys(obj1).reduce((result, key) => {
    if (!obj2.hasOwnProperty(key)) {
      result.push(key);
    } else if (_.isEqual(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key);
      result.splice(resultKeyIndex, 1);
    }
    return result;
  }, Object.keys(obj2));
  const returnObject = {};
  diff.map((key) => {
    returnObject[key] = obj1[key];
  });

  return returnObject;
};

export const createRolesAndAccessPayload = (type, accessValue = "") => {
  const userScope =
    type === "trial" ? "Study" : type === "country" ? "Country" : "Site";

  return [
    {
      userRole: "SITESTAFF",
      userScope: userScope,
      access: accessValue,
    },
    {
      userRole: "SPONSOR-STUDY",
      userScope: userScope,
      access: accessValue,
    },
    {
      userRole: "SPONSOR-COUNTRY",
      userScope: userScope,
      access: accessValue,
    },
    {
      userRole: "SPONSOR-SITE",
      userScope: userScope,
      access: accessValue,
    },
    {
      userRole: "SPONSOR-REVIEW",
      userScope: userScope,
      access: accessValue,
    },
    {
      userRole: "SPONSOR-DM",
      userScope: userScope,
      access: accessValue,
    },
    {
      userRole: "SPONSOR-UNBLINDED",
      userScope: userScope,
      access: accessValue,
    },
  ];
};

export const constructDisplayOrder = (status, time) => {
  switch (status) {
    case "Unpublished":
      return 3;
    case "Awaiting review":
      return 2;
    case "Flagged by QC":
      return 2;
    case "Finalized":
      return 2;
    case "Scanning in progress":
      return 1;
    default:
      return 0;
  }
};

export const permissionObject = (data) => {
  const {
    artifactuseraccess,
    rolePermission,
    documenttmflevel,
    sitesid,
    countriesid,
    countrySiteList,
  } = data;
  const allowedSite = countrySiteList.site.map((obj) => obj.id);
  const allowedCountry = countrySiteList.country.map((obj) => obj.id);
  let isIncludes = (arr, target) => target.every((v) => arr.includes(v));

  let writePermission = false;
  let reviewPermission = false;
  const returnReviewPermission = (filterUserAccessArr, from) => {
    let permissionArray = [];
    let reviewCount = 0;
    let permission = false;
    if (from !== "") {
      _.map(filterUserAccessArr, (dataObj) => {
        permissionArray = [...permissionArray, ...dataObj.access];
        if (dataObj.access.includes("REVIEW")) reviewCount++;
        permission = filterUserAccessArr.length === reviewCount;
      });
    } else {
      _.map(filterUserAccessArr, (dataObj) => {
        permissionArray = [...permissionArray, ...dataObj.access];
        if (dataObj.access.includes("REVIEW")) reviewCount++;
        permission = reviewCount !== 0;
      });
    }
    return permission;
  };
  const returnPermissionObj = (from, idList, allowedList) => {
    let findObj = {};
    let filterUserAccessArr = _.filter(artifactuseraccess, (filterObj) => {
      return filterObj.userScope === from;
    });
    const scopeCodeList = !_.isEmpty(filterUserAccessArr)
      ? filterUserAccessArr.map((obj) => obj.scopeCode)
      : [];
    if (from !== "Study") {
      if (_.isEmpty(idList)) {
        writePermission =
          rolePermission === "WRITE" || rolePermission === "SIGN";
        reviewPermission = returnReviewPermission(filterUserAccessArr, from);
      } else {
        let permissionArray = [];
        let reviewCount = 0;
        _.map(filterUserAccessArr, (dataObj) => {
          if (idList.includes(dataObj.scopeCode)) {
            permissionArray = [...permissionArray, ...dataObj.access];
            if (dataObj.access.includes("REVIEW")) reviewCount++;
          }
        });
        if (
          isIncludes(allowedList, idList) &&
          isIncludes(scopeCodeList, idList)
        ) {
          writePermission =
            permissionArray.includes("WRITE") ||
            permissionArray.includes("SIGN");
          reviewPermission = idList.length === reviewCount;
        } else {
          writePermission = false;
          reviewPermission = false;
        }
      }
    } else {
      findObj = _.find(filterUserAccessArr, (filterObj) => {
        return filterObj.userScope === "Study";
      });
      writePermission =
        findObj &&
        (findObj.access.includes("WRITE") || findObj.access.includes("SIGN"));
      reviewPermission = findObj && findObj.access.includes("REVIEW");
    }
  };
  switch (documenttmflevel) {
    case "Site":
      returnPermissionObj(documenttmflevel, sitesid, allowedSite);
      break;
    case "Country":
      returnPermissionObj(documenttmflevel, countriesid, allowedCountry);
      break;
    case "Trial":
      returnPermissionObj("Study");
      break;
    default:
      writePermission =
        _.isEmpty(documenttmflevel) &&
        (rolePermission === "WRITE" || rolePermission === "SIGN");
      reviewPermission = returnReviewPermission(artifactuseraccess, "");
      break;
  }
  return { writePermission, reviewPermission };
};

export const removeDuplicates = (list, key) => {
  if (!_.isEmpty(list))
    return list.filter(
      (ele, index) =>
        index ===
        list.findIndex(
          (obj) =>
            (!_.isEmpty(obj[key]) && obj[key].toLowerCase()) ===
            (!_.isEmpty(ele[key]) && ele[key].toLowerCase())
        )
    );
  else return list;
};

export const restrictTagsAndSpaces = (value) => {
  // To restrict HTML tags and script tags
  // let updatedValue = value.replace(/(<([^>]+)>)/gi, "");
  let updatedValue = value;
  // To restrict spaces at the beginning of first word
  if (updatedValue.trim() === "") {
    if (/^\s.*/.test(updatedValue)) updatedValue = updatedValue.trim();
  } else {
    if (/^\s.*/.test(updatedValue)) updatedValue = updatedValue;
  }
  return updatedValue;
};

export const getFormattedDateTimeNoLocalConversion = (
  format,
  fullDate,
  locale
) => {
  if (fullDate === null) {
    return;
  }
  let splitedDate = fullDate.split("-");
  let replacedFormat = format;
  replacedFormat = replacedFormat
    .replace(/\bdddd\b/, "cccc")
    .replace(/\bH:mm:ss tt\b/, "H:mm:ss a")
    .replace(/\bHH:mm:ss tt\b/, "HH:mm:ss a")
    .replace(/\bH:mm tt\b/, "H:mm a")
    .replace(/\bHH:mm tt\b/, "HH:mm a")
    .replace(/\bh:mm:ss tt\b/, "h:mm:ss a")
    .replace(/\bhh:mm:ss tt\b/, "hh:mm:ss a")
    .replace(/\bh:mm tt\b/, "h:mm a")
    .replace(/\bhh:mm tt\b/, "hh:mm a");
  return DateTime.local(
    parseInt(splitedDate[0]),
    parseInt(splitedDate[1]),
    parseInt(splitedDate[2])
  )
    .setLocale(locale)
    .toFormat(replacedFormat);
};

export const getUtcCurrentTimeforExport = () => {
  return moment.utc().format("YYYYMMDDHHmmss");
};

export const getSignReasonTranslateKey = (value) => {
  const ReasonTranslateKey = {
    TEXT_DROPDOWNSUBREASON1:
      "I confirm that I have read and understand the contents of the document. I agree to take part in the study.",
    TEXT_DROPDOWNCOREASON1:
      "I certify that the participant signing this document had the study fully and carefully explained to him/her by me.",
    TEXT_DROPDOWNREASON1:
      "I have read and understood the contents of the file.",
    TEXT_DROPDOWNREASON2: "I attest the accuracy of this file.",
    TEXT_DROPDOWNREASON3: "I have reviewed and approve this file.",
    TEXT_DROPDOWNREASON4: "I agree to the file.",
    TEXT_DROPDOWNREASON5: "I attest the accuracy of the wet ink signature.",
  };
  return Object.keys(ReasonTranslateKey).find(key => ReasonTranslateKey[key] === value);
}

export const errorDownloadFile = (error, fileName) => {
  const link = document.createElement("a");
  // create a blobURI pointing to our Blob
  const errorBlob = new Blob([error]);
  link.href = URL.createObjectURL(errorBlob);
  link.download = fileName;
  // some browser needs the anchor to be in the doc
  document.body.append(link);
  link.click();
  link.remove();
  // in case the Blob uses a lot of memory
  setTimeout(() => URL.revokeObjectURL(link.href), 7000);
};

export const checkCurlyBracesValue = (value, from, documentTemplateNames) => {
  let updatedValue = value;
  let format = /{(.*?)}/;
  let displayNameFormat = /^[*|":/\\<>$]+$/;
  let documentNames = documentTemplateNames;
  if (from !== "displaytemplate" && !_.isEmpty(updatedValue) && !displayNameFormat.test(updatedValue) && !format.test(updatedValue)) {
    return true;
  } else {
    if (!_.isEmpty(updatedValue) && format.test(updatedValue)) {
      if (updatedValue && updatedValue.includes("{}") === false) {
        let path = updatedValue;
        const paramsPattern = /[^{\}]+(?=})/g;
        let extractParams = path.match(paramsPattern);
        const docNames = Array.from(new Set(extractParams));
        let isValid;
        if (extractParams && extractParams !== null) {
          isValid = documentNames.filter(Names => extractParams.includes(Names));
        }
        if (isValid && isValid !== undefined && extractParams !== null) {
          if (isValid.length === docNames.length)
            return true;
          else
            return false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
};
export const getInvalidNames = (templateName, documentTemplateNames) => {
  const paramsPattern = /[^{\}]+(?=})/g;
  let format = /{(.*?)}/;
  let extractParams;
  if (!_.isEmpty(templateName) && format.test(templateName)) {
    extractParams = templateName.match(paramsPattern);
  }
  let invalidError = "";
  if (extractParams && extractParams !== null) {
    let invalidNames = extractParams.filter(num => !documentTemplateNames.some(id => id === num));
    if (templateName && !templateName.includes("{}")) {
      invalidError = invalidNames.map(item => "{" + item + "}");
    } else {
      invalidError = "{}" + invalidNames.map(item => "{" + item + "}");
    }
  } else if (templateName && templateName.includes("{}")) {
    invalidError = "{}";
  }
  return invalidError;
}

export async function loadAppSettings(reload) {
  let settings = StorageHelper.getAppSettings();
  if (_.isEmpty(settings)) {
    settings = await fetchAppSettings();
    if (settings) {
      StorageHelper.setAppSettings(settings);
    }
  } else {
    StorageHelper.setAppSettings(settings);
  }
  if (reload) {
    window.location.reload();
  }
}

async function fetchAppSettings() {
  try {
    const response = await fetch("/appsettings.json");
    if (!response.ok) {
      throw new Error("Cannot load appsettings");
    }
    const data = await response.json();
    StorageHelper.setAppSettings(data);
    return data;
  } catch (error) {
    return null;
  }
}

export const getTokenInfoCookieDetails = () => {
  const cookies = document.cookie;
  const splitCookies = cookies.split("; ");
  const cookieMap = {};
  splitCookies.forEach((cookie) => {
    const [name, value] = cookie.split("=");
    cookieMap[name] = value;
  });
  const tokenValue = cookieMap["tokenInfo"];
  const expiryDate = cookieMap["tokenExpiry"];

  return {
    tokenInfo: tokenValue,
    tokenExpiry: expiryDate,
  };
}

export const addHours = (date, hours) => {
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);

  return date;
}

export const getTranslatedScopeLabel = (scope) => {
  switch (scope) {
    case "Trial":
      return i18n.t("TMF.TEXT_TRIALLBL");
    case "Site":
      return i18n.t("TMF.TEXT_SITELBL");
    case "Country":
      return i18n.t("TMF.TEXT_COUNTRYLBL");
    case "Select record type":
        return i18n.t("TMF.PLACEHOLDER_SELECTDOCUMENTTYPE");
    case "Select scope":
      return `${i18n.t("ADMIN.ADMINTAB_SELECT")} ${i18n.t("TMF.TEXT_SCOPE").toLowerCase()}`;
    default:
        return scope;
  }
};

export const getMilestoneGroupLabel = (label) => {
    switch (label) {
      case "Start Up":
        return i18n.t("ADMIN.REVIEWPOPUP_STARTUP");
      case "Study Conduct":
        return i18n.t("ADMIN.REVIEWPOPUP_STUDYCONDUCT");
      case "Close Out":
        return i18n.t("ADMIN.REVIEWPOPUP_CLOSEOUT");
      case "Other":
        return i18n.t("ADMIN.TEXT_OTHER");
      default:
        return label;
    }
  };

export const getRecordStatus = (status) => {
  switch(status) {
    case "Unpublished":
      return i18n.t("TMF.TEXT_UNPUBLISHED");
    case "Awaiting review":
      return i18n.t("TMF.TEXT_AWAITING");
    case "Flagged by QC":
      return i18n.t("TMF.TEXT_FLAGGEDBYQC");
    case "Finalized":
      return i18n.t("TMF.TEXT_FINALIZED");
    default:
      return status;
  }
}

export const findObject = (list, key, selectedvalue) => {
  if(!_.isEmpty(list) && key && selectedvalue){
     const foundObject = list?.find(obj => obj[key] === selectedvalue);
     return !_.isEmpty(foundObject) ? foundObject : {};
  } else  return {}
}